/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Paper, Grid, Box, Tabs, Tab } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";

import Layout from "../../../../components/layout/Layout";
import Form from "./Form";
import Cost from "./Cost";
import Driver from "./Driver";
import Transports from "./Transports";
import { useCanView } from "../../../../config/hook/UserPermissions";

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && <Box>{children}</Box>}
        </div>
    );
}

const NewEdit = () => {
    const [__] = useTranslation("supplierMaster");
    const [btns, setBtns] = useState(<></>);
    const location = useLocation();
    const navigate = useNavigate();
    const initialTab = location.state?.tab || 0;
    const [value, setValue] = React.useState(initialTab);
    const canView = useCanView();

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    useEffect(() => {
        if (location.state?.tab) {
            navigate(location.pathname, { replace: true, state: {} });
        }
    }, [location, navigate]);

    const tabs = [
        {
            label: __(`tabs.supplier`),
            component: <Form setBtns={setBtns} __={__} />,
            visible: true, 
        },
        {
            label: __(`tabs.costs`),
            component: <Cost setBtns={setBtns} __={__} />,
            visible: canView("MAESTROS/PROVEEDORES/COSTOS", "watch"),
        },
        {
            label: __(`tabs.trucks`),
            component: <Transports setBtns={setBtns} __={__} />,
            visible: canView("MAESTROS/PROVEEDORES/CAMIONES", "watch"),
        },
        {
            label: __(`tabs.drivers`),
            component: <Driver setBtns={setBtns} __={__} />,
            visible: canView("MAESTROS/PROVEEDORES/CONDUCTORES", "watch"),
        },
    ];

    const visibleTabs = tabs.filter((tab) => tab.visible);

    return (
        <Layout
            propsToolbar={{
                title: __(`head.edit.name`),
                srute: __(`head.edit.code`),
            }}
        >
            <Box display="block">
                <Box className="ml-4 mr-0">
                    <Grid className="py-2" container component={Paper} spacing={2}>
                        <Grid item xs={12} lg={5}>
                            <Tabs
                                value={value}
                                onChange={handleChange}
                                variant="scrollable"
                                scrollButtons
                                allowScrollButtonsMobile
                                aria-label="scrollable force tabs example"
                            >
                                {visibleTabs.map((tab, index) => (
                                    <Tab key={index} label={tab.label} />
                                ))}
                            </Tabs>
                        </Grid>
                        <Grid item xs={12} lg={7}>
                            {btns}
                        </Grid>
                    </Grid>
                </Box>
                {visibleTabs.map((tab, index) => (
                    <TabPanel key={index} value={value} index={index}>
                        {tab.component}
                    </TabPanel>
                ))}
            </Box>
        </Layout>
    );
};

export default NewEdit;
